import { render } from "./PartnerWasteReports.vue?vue&type=template&id=645ecf13"
import script from "./PartnerWasteReports.vue?vue&type=script&lang=js"
export * from "./PartnerWasteReports.vue?vue&type=script&lang=js"

import exportComponent from "/home/le01s/WebstormProjects/am_logger_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__